import { render, staticRenderFns } from "./CommentCreateUpdateList.vue?vue&type=template&id=5f407594&scoped=true&"
import script from "./CommentCreateUpdateList.vue?vue&type=script&lang=js&"
export * from "./CommentCreateUpdateList.vue?vue&type=script&lang=js&"
import style0 from "./CommentCreateUpdateList.vue?vue&type=style&index=0&id=5f407594&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f407594",
  null
  
)

export default component.exports